import axios from "axios";
import Cookies from "js-cookie";

export default {
  namespaced: true,
  state: {
    isUploadTypesRestricted: true,
    isUploadConfigLoaded: false,
    allowedFileTypes: [],
    options: {
      url: null,
      acceptedFiles: [
        ".psd",
        ".pdd",
        ".psdt",
        ".psb",
        ".pdf",
        ".tif",
        ".tiff",
        ".eps",
        ".ai",
        ".jpg",
        ".jpeg",
        ".jpe",
        ".jp2",
        ".png",
        ".tga",
        ".bmp",
        ".gif",
        ".doc",
        ".docx",
        ".svg",
        ".webp",
        ".cr2",
        ".crw",
        ".dcr",
        ".dng",
        ".exr",
        ".epdf",
        ".heic",
        ".nef",
        ".orf",
        ".wmf",
        ".cdr",
        ".emb",
        ".erf",
        ".nrw",
        ".pef",
        ".raf",
        ".rw2",
        ".cr3",
        ".xmp",
        ".arw",
      ],
      parallelUploads: 5,
      uploadMultiple: false,
      headers: {
        Authorization: "Bearer " + Cookies.get("token"),
      },
    },
  },
  getters: {
    options(state) {
      return state.options;
    },
    isUploadTypesRestricted(state) {
      return state.isUploadTypesRestricted;
    },
    isUploadConfigLoaded(state) {
      return state.isUploadConfigLoaded;
    },
    effectiveFileTypes(state) {
      if (!state.isUploadTypesRestricted) return null;
      
      return state.allowedFileTypes.length > 0
        ? state.allowedFileTypes
        : state.options.acceptedFiles;
    },
  },
  mutations: {
    SET_URL(state, url) {
      state.options.url = url;
    },
    SET_UPLOAD_CONFIG(state, { isRestricted, allowedFileTypes }) {
      state.isUploadTypesRestricted = isRestricted;
      state.allowedFileTypes = allowedFileTypes ?? [];
      state.isUploadConfigLoaded = true;
    },
  },
  actions: {
    setUrl({ commit }, payload) {
      commit("SET_URL", payload.url);
    },
    async fetchUploadConfig({ commit, state }) {
      if (state.isUploadConfigLoaded) return;

      try {
        const { data } = await axios.get("upload-config");
        const isRestricted = data.is_upload_types_restricted ?? true;
        const allowedFileTypes = data.allowed_file_types ?? [];
        commit("SET_UPLOAD_CONFIG", { isRestricted, allowedFileTypes });
      } catch (err) {
        console.error("fetchUploadConfig error: ", err);
        commit("SET_UPLOAD_CONFIG", { isRestricted: true, allowedFileTypes: [] });
      }
    },
  },
};
